import { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

const GridView = ({ children }: Props) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-y-6 gap-x-4 sm:gap-x-6">
      {children}
    </div>
  )
}

export default GridView
